import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function Footer() {
  return (
    <footer className="bg-dark text-white py-3 w-100">
      <Container>
        <Row className="align-items-center">
          {/* Company Name */}
          <Col
            xs={12}
            sm={12}
            md={3}
            className="mb-3 mb-md-0 text-center text-md-start"
          >
            <h6 className="mb-0">The Style Emporium &copy;2024</h6>
          </Col>

          {/* Address and Phone */}
          <Col xs={12} sm={12} md={6} className="mb-3 mb-md-0">
            <Row className="justify-content-center">
              {/* Address */}
              <Col xs={6} className="d-flex justify-content-center">
                <div className="d-flex">
                  <div className="me-2">
                    {/* <FontAwesomeIcon icon={faLocationDot} size="sm" /> */}
                  </div>
                  <div className="small text-center">
                    5041 N Academy Blvd,
                    <br />
                    Colorado Springs, CO, 80918
                  </div>
                </div>
              </Col>

              {/* Phone */}
              <Col xs={6} className="d-flex justify-content-center">
                <div className="d-flex">
                  <div className="me-2">
                    {/* <FontAwesomeIcon icon={faPhone} size="sm" /> */}
                  </div>
                  <div className="small text-center">719-452-1343</div>
                </div>
              </Col>
            </Row>
          </Col>

          {/* Social Media */}
          <Col xs={12} sm={12} md={3} className="text-center text-md-end">
            {/* <a href="#" className="text-white"></a> */}
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
